import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import IconButton from "@mui/material/IconButton"
import ArrowUpward from "@mui/icons-material/ArrowUpward"
import ArrowDownward from "@mui/icons-material/ArrowDownward"
import { shuffle, sanitizeYaml } from "../../utilities"
import linkifyHtml from "linkify-html"

export default class SortableList extends Component {
  interact = (index, direction, roomCode, participantId) => {
    fetch(
      window.location.pathname === "/admin"
        ? `${process.env.REACT_APP_SERVER_URL}/room/interact?roomCode=${roomCode}`
        : `${process.env.REACT_APP_SERVER_URL}/room/interact?roomCode=${roomCode}&participantId=${participantId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          index,
          direction,
        }),
      }
    )
  }

  render() {
    const { text, items, slideState, roomCode, participantId } = this.props

    const shuffledAnswers = shuffle(items, slideState.positions)

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "min(960px, calc(100% - 64px))",
          maxHeight: "calc(100% - 64px)",
          overflow: "auto",
          padding: "32px",
        }}
      >
        {text && (
          <div
            style={{
              textAlign: "center",
              textTransform: "none",
              padding: "32px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
            }}
          >
            <Typography
              variant="h4"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(sanitizeYaml(text), {
                  target: "_blank",
                  attributes: {
                    class: "underlineOnHover",
                  },
                }),
              }}
            />
          </div>
        )}
        {shuffledAnswers.map((nome, index) => (
          <div
            style={{
              display: "flex",
              textTransform: "none",
              marginTop: !text && index === 0 ? 0 : "16px",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, .8)",
              backdropFilter: "blur(16px)",
            }}
          >
            <Typography
              variant="h4"
              style={{
                fontWeight: 300,
                padding: "24px 0 24px 32px",
                width: "calc(100% - 64px)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              dangerouslySetInnerHTML={{
                __html: linkifyHtml(
                  (window.location.pathname === "/admin"
                    ? `<b>${items.indexOf(nome) + 1 + "° "}</b>`
                    : "") + sanitizeYaml(nome),
                  {
                    target: "_blank",
                    attributes: {
                      class: "underlineOnHover",
                    },
                  }
                ),
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginRight: "12px",
              }}
            >
              <IconButton
                disabled={!index}
                style={{
                  color: !index ? null : "black",
                }}
                onClick={() =>
                  this.interact(index, "up", roomCode, participantId)
                }
              >
                <ArrowUpward style={{ fontSize: "1.5rem" }} />
              </IconButton>
              <IconButton
                disabled={index === items.length - 1}
                style={{
                  color: index === items.length - 1 ? null : "black",
                }}
                onClick={() =>
                  this.interact(index, "down", roomCode, participantId)
                }
              >
                <ArrowDownward style={{ fontSize: "1.5rem" }} />
              </IconButton>
            </div>
          </div>
        ))}
      </div>
    )
  }
}
